(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["women-rise-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-wr-ritual-toggle]').forEach(function(button) {
  button.addEventListener('click', function() {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    const detail = document.getElementById(button.getAttribute('aria-controls'));
    button.setAttribute('aria-expanded', String(!expanded));
    if (detail) detail.hidden = expanded;
    const icon = button.querySelector('[data-wr-toggle-icon]');
    if (icon) icon.textContent = expanded ? '+' : '−';
  });
});

document.querySelectorAll('.wr7-brands').forEach(function(section) {
  const rail = section.querySelector('[data-wr-brand-rail]');
  const previous = section.querySelector('[data-wr-brand-prev]');
  const next = section.querySelector('[data-wr-brand-next]');
  const belt = section.querySelector('.wr-brand-marquee__belt');
  const firstGroup = section.querySelector('.wr-brand-marquee__group');
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!rail || !previous || !next || !belt || !firstGroup) return;
  let manualShift = 0;
  let lastFrame = 0;
  function step() {
    const link = firstGroup.querySelector('.wr-brand-marquee__link');
    const gap = parseFloat(getComputedStyle(firstGroup).columnGap) || 0;
    return link ? link.getBoundingClientRect().width + gap : 150;
  }
  function move(direction) {
    if (mobile.matches && !reduced.matches) {
      const width = firstGroup.getBoundingClientRect().width;
      if (direction < 0 && rail.scrollLeft < step()) rail.scrollLeft += width;
      manualShift += direction * step();
    } else if (reduced.matches) {
      if (direction < 0 && rail.scrollLeft < step() / 2) rail.scrollLeft = rail.scrollWidth - rail.clientWidth;
      if (direction > 0 && rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2) rail.scrollLeft = 0;
      rail.scrollBy({ left: direction * step(), behavior: 'instant' });
    } else {
      const animation = belt.getAnimations().find(function(item) { return item.animationName === 'wr-brand-travel'; });
      if (!animation) return;
      const duration = animation.effect.getTiming().duration;
      const count = firstGroup.querySelectorAll('.wr-brand-marquee__link').length;
      animation.currentTime = ((animation.currentTime || 0) + direction * duration / count + duration) % duration;
      animation.play();
    }
  }
  previous.addEventListener('click', function() { move(-1); });
  next.addEventListener('click', function() { move(1); });
  function advance(now) {
    const delta = Math.min(64, now - (lastFrame || now));
    lastFrame = now;
    if (mobile.matches && !reduced.matches && document.visibilityState === 'visible') {
      const width = firstGroup.getBoundingClientRect().width;
      const extra = Math.sign(manualShift) * Math.min(Math.abs(manualShift), delta * 1.15);
      manualShift -= extra;
      rail.scrollLeft += delta * 0.028 + extra;
      if (width > 0 && rail.scrollLeft >= width) rail.scrollLeft -= width;
      if (width > 0 && rail.scrollLeft < 0) rail.scrollLeft += width;
    }
    requestAnimationFrame(advance);
  }
  requestAnimationFrame(advance);
});

  } catch(e) { console.error(e); }
})();
})();
